import { ENV_NAME, getEnvironment } from '@heidi/api/config';

interface CopilotDebugEnvironment {
  environment: ENV_NAME | undefined;
}

const CONFIGURED_ENVIRONMENTS = new Set([
  'localhost',
  'azure_dev',
  'development',
  'staging',
  'production',
]);

// getEnvironment intentionally falls back to DEV, so validate the build token
// first to keep unknown packaged channels fail-closed.
const getConfiguredEnvironment = (): ENV_NAME | undefined =>
  CONFIGURED_ENVIRONMENTS.has(process.env.NEXT_PUBLIC_ENVIRONMENT ?? '')
    ? getEnvironment()
    : undefined;

export const isCopilotDebugAllowed = (
  environment: CopilotDebugEnvironment = {
    environment: getConfiguredEnvironment(),
  }
): boolean =>
  environment.environment === ENV_NAME.DEV ||
  environment.environment === ENV_NAME.STAGING ||
  environment.environment === ENV_NAME.AZURE_DEV ||
  environment.environment === ENV_NAME.LOCALHOST;
